/**
 * @generated SignedSource<<659262241461115107b17de92f8a9483>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerInfo_seller$data = {
  readonly agreementStart: string | null;
  readonly analytics: {
    readonly metrics: {
      readonly responseTime: {
        readonly value: number | null;
      } | null;
    } | null;
  } | null;
  readonly liveStorefrontProfile: {
    readonly establishmentYear: string | null;
  } | null;
  readonly monthsSinceStartDate: number | null;
  readonly sellerOrderQuantity: number | null;
  readonly shippingAddress: {
    readonly displayFullCityStateCountry: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerAssociations_seller">;
  readonly " $fragmentType": "PdpSharedSellerInfo_seller";
};
export type PdpSharedSellerInfo_seller$key = {
  readonly " $data"?: PdpSharedSellerInfo_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerInfo_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerInfo_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerAssociations_seller"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agreementStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sellerOrderQuantity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalytics",
      "kind": "LinkedField",
      "name": "analytics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCAnalyticsMetrics",
          "kind": "LinkedField",
          "name": "metrics",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MCMetricResponseTime",
              "kind": "LinkedField",
              "name": "responseTime",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "establishmentYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "shippingAddress",
      "plural": false,
      "selections": [
        {
          "alias": "displayFullCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "c0f6d4ec0f9b29618b44fe337f767d16";

export default node;
